export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-tnn-warm border-t border-tnn-ink/8">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-8">
          <img
            src="/assets/logo.png"
            alt="The Nutrition Network Africa"
            className="w-44 max-w-[62vw] h-auto"
            data-testid="footer-logo"
          />
          <div className="sm:text-right">
            <p className="text-sm font-medium text-tnn-ink" data-testid="footer-tagline">
              Nutrition · Technology · Innovation · Better Health
            </p>
            <p className="mt-1.5 text-xs font-semibold tracking-[0.22em] uppercase text-tnn-muted" data-testid="footer-location">
              Est. 2021 · Africa · Europe
            </p>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-tnn-ink/8">
          <p className="text-sm text-tnn-muted" data-testid="footer-signoff">
            Nutritionally yours, with love <span role="img" aria-label="love">❤️</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
